import React, { useState } from 'react'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import List from '@material-ui/core/List'
import { useTheme } from '@material-ui/core/styles'
import { NavLink, useLocation } from 'react-router-dom'
import { MenuInfo, Props } from './model'
// import logoSrc from 'src/assets/icon/home-logo.svg'
import IconDecide from '../IconDecide'
import classNames from 'classnames'
import { ReactComponent as ArrowUp } from 'src/assets/icon/arrow-up-icon.svg'
import { ReactComponent as ArrowDown } from 'src/assets/icon/arrow-down-icon.svg'
import LanguageButton from '../LanguageButton'
import youtubeIcon from 'src/assets/icon/youtube-icon.svg'
import facebookIcon from 'src/assets/icon/facebook-icon.svg'
import LogoSrc from 'src/assets/img/logo.png'
import { AppBar, IconButton, Toolbar, useMediaQuery } from '@material-ui/core'
import { useLanguage } from 'src/core/components/LanguageProvider/hooks'
import { useTranslation } from 'react-i18next'
import useStyles from './useStyles'
import { ReactComponent as MenuIcon } from 'src/assets/icon/menu-icon.svg'
import { ReactComponent as CloseIcon } from 'src/assets/icon/close-icon.svg'
// import { ReactComponent as SearchIcon } from 'src/assets/icon/search-icon.svg'

const Menu: React.FC<Props> = ({ window, isMenuOpen, setIsMenuOpen, menuData }: Props) => {
  // const { url } = useRouteMatch()
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const classes = useStyles()
  const theme = useTheme()
  const matchTablet = useMediaQuery(theme.breakpoints.up('md'))
  const { language } = useLanguage()
  const isChinese = language === 'zh-TW'
  const [menuArray, setMenuArray] = useState<MenuInfo[] | undefined>(menuData)

  React.useEffect(() => {
    if (menuData) {
      setMenuArray(menuData)
    }
  }, [menuData])

  // const history = useHistory()

  const handleDrawerToggle = () => {
    if (matchTablet) return
    setIsMenuOpen(!isMenuOpen)
  }
  React.useEffect(() => {
    if (matchTablet && isMenuOpen) {
      setIsMenuOpen(false)
    }
  }, [matchTablet])

  // Set default opened menu
  React.useEffect(() => {
    menuArray?.map((item) => {
      if (pathname.includes(`${item.path}/`)) {
        const newMenuArray = menuArray?.map((value) => {
          const isCurrentItem = value.id === item.id
          if (isCurrentItem) {
            return { ...value, arrow: item.arrow }
          } else {
            if (value.sub_menu) {
              value.arrow = false
            }
            return value
          }
        })
        setMenuArray(newMenuArray)
      }
    })
  }, [pathname])
  const renderMenu = (item: MenuInfo, isOpenChildren = true, index: number) => {
    const menuList = classNames({
      [classes.listItem]: true,
      [classes.listItemFirstChild]: index === 0,
      [classes.listItemChild]: !!item.parentId,
      [classes.isShowMenuItem]: !isOpenChildren,
    })
    const itemText = classNames({
      [classes.itemText]: true,
      [classes.itemTextChild]: !!item.parentId,
      ['mrLt1']: !!item.parentId,
    })
    if (item.sub_menu) {
      //has children
      return (
        <div key={item.key}>
          <div
            className={`${classes.listItemParnet} ${pathname.includes(`${item.path}/`) ? classes.itemActive : ''}`}
            onClick={() => {
              const newMenuArray = menuArray?.map((value) => {
                const isCurrentItem = value.id === item.id
                if (isCurrentItem) {
                  return { ...value, arrow: !item.arrow }
                } else {
                  if (value.sub_menu) {
                    // cancel so all sub menu can be opened at once
                    // value.arrow = false
                  }
                  return value
                }
              })
              setMenuArray(newMenuArray)
            }}
          >
            <div className='listItemParnetBox'>
              <div className='itemSliderActive' />
              <div className={classes.itemIcon}>
                <IconDecide src={item.icon ? item.icon : ''} />
              </div>
              <div className={classes.itemText}>{isChinese ? item.menu_name_ch : item.menu_name_en}</div>
            </div>
            {item.arrow ? <ArrowUp /> : <ArrowDown />}
          </div>
          {item.sub_menu.map((subMenuItem: MenuInfo, itemIndex) => renderMenu(subMenuItem, item.arrow, itemIndex))}
        </div>
      )
    } else {
      let linkUrl
      let target='_blank'
      switch (item.path) {
        case 'about/faq':
          linkUrl = isChinese ? 'https://www.brightenoptix.com/news31_1.htm' : 'https://www.brightenoptix.com/en/index.htm'
          break
        case 'about/about-btox-ec':
          linkUrl = isChinese ? 'https://www.brightenoptix.com/about.htm' : 'https://www.brightenoptix.com/en/about.htm'
          break
        case 'about/contact':
          linkUrl = isChinese ? 'https://www.brightenoptix.com/contact.htm' : 'https://www.brightenoptix.com/en/contact.htm'
          break
        case 'about/news':
          linkUrl = isChinese ? 'https://www.brightenoptix.com/investor38_0_0_1.htm' : 'https://www.brightenoptix.com/en/investor38_0_0_1.htm'
          break
        default:
          linkUrl = `/pages/${item.path}`
          target = ''
      }

      return (
        <React.Fragment key={item.key}>
          <NavLink to={{ pathname: linkUrl }} target={target} onClick={handleDrawerToggle} className={menuList} activeClassName={classes.itemActive}>
            {!item.parentId && <div className='itemSliderActive' />}
            <div className={classes.itemIcon}>{!item.parentId ? <IconDecide src={item.icon ? item.icon : ''} /> : <div className='spaceIcon' />}</div>
            <div className={itemText}>{isChinese ? item.menu_name_ch : item.menu_name_en}</div>
          </NavLink>
          {item.id === 4 && item.parentId === null && <Divider className={classes.divider} />}
        </React.Fragment>
      )
    }
  }

  const drawer = (
    <div className={classes.container}>
      <div>
        <div className={classes.toolbar}>
          <img src={LogoSrc} alt='' className={classes.logoImg} />
        </div>
        {/* <div onClick={() => history.push(`/simulation-adaptation/patient-list`)} className={classes.toolbarlg}>
          <div className={classes.toolbarlgIcon}>
            <img src={logoSrc} alt='' />
            <div>{t('home.simulationAdaptation')}</div>
          </div>
        </div> */}
        <br></br>
        <List>{menuArray?.map((item, index) => renderMenu(item, item.arrow, index))}</List>
      </div>

      <div className={classes.menuFooter}>
        <a href='https://www.youtube.com/@brightenoptix8378'>
          <img className={classes.footerImg} src={youtubeIcon} alt='YouTube' />
        </a>
        <a href='https://www.facebook.com/BrightenOptix/'>
          <img className={classes.footerImg} src={facebookIcon} alt='FaceBook' />
        </a>
        <LanguageButton className={`${classes.languageButton} ${classes.displayControl}`} />
        <div className='menuFooterTxt'>{t('global2')}</div>
      </div>
    </div>
  )

  const container = window !== undefined ? () => window().document.body : undefined

  // const handleSearch = () => {
  //   handleDrawerToggle()
  //   history.push('/pages/products/search-results')
  //   localStorage.setItem('searchReturnPath', pathname)
  // }

  return (
    <nav className={classes.drawer} aria-label='mailbox folders'>
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Hidden mdUp implementation='css'>
        <Drawer
          container={container}
          variant='temporary'
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={isMenuOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <AppBar position='fixed' className={classes.appBar}>
            <Toolbar>
              <IconButton disableRipple aria-label='open drawer' edge='start' onClick={handleDrawerToggle} className={classes.menuButton}>
                {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
              <img className={classes.headerTopLg} src={LogoSrc} alt='' />
              {/* <IconButton onClick={handleSearch} style={{ color: '#ffff' }}>
                <SearchIcon />
              </IconButton> */}
            </Toolbar>
          </AppBar>
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation='css'>
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant='permanent'
          open
        >
          {drawer}
        </Drawer>
      </Hidden>
    </nav>
  )
}

export default Menu
